import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	data: [],
	loaded: false,
	fetching: false,
}

const talentCategories = createSlice({
	name: 'talentCategories',
	initialState,
	reducers: {
		fetched(state, { payload }) {
			if (payload.length) {
				state.data = payload
				state.loaded = true
				state.fetching = false
			}
		},

		fetching(state, { payload }) {
			state.fetching = payload
		},

		loaded(state, { payload }) {
			state.loaded = payload
		},
	},
})

export const Creators = talentCategories.actions

export default talentCategories.reducer
